import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface TenantOidcConfig {
  name: string;
  clientID: string;
  authority: string;
  redirectUrl: string;
  scope: string;
  responseType: string;
  tenantId?: string;
  logoUrl?: string;
  title?: string;
  footer?: string;
  cssPath?: string;
  language?: string;
}

@Injectable({
  providedIn: 'root'
})
export class OidcConfigService {
  private readonly contentType = 'application/json';

  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Fetches tenant OIDC configuration from Lambda
   * @param tenantName - The name of the tenant/opco
   * @returns Observable with tenant configuration
   */
  getTenantConfig(tenantName: string): Observable<TenantOidcConfig> {
    const headers = new HttpHeaders({
      'Content-Type': this.contentType,
      'operation': 'get_tenant_basic_profile'
    });

    return this.httpClient.get<TenantOidcConfig>(
      `${environment.lamdaUrl}get_tenant_basic_profile?name=${tenantName}`,
      { headers }
    );
  }
}

